import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const btn = event.currentTarget
    const productId = btn.dataset.productId
    const isCollapsed = btn.dataset.collapsed === "true"

    // Toggle variant rows
    this.element.querySelectorAll(`[data-parent-product-id="${productId}"]`).forEach(row => {
      row.style.display = isCollapsed ? "" : "none"
    })

    // Flip chevron and state
    btn.dataset.collapsed = isCollapsed ? "false" : "true"
    btn.title = isCollapsed ? "Collapse variants" : "Expand variants"
    btn.querySelector(".variant-chevron").style.transform = isCollapsed ? "rotate(0deg)" : "rotate(-90deg)"
  }
}
